var _path, _path2, _path3, _circle, _circle2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 152,
    viewBox: "0 0 348 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.525 94.6952V117.658H1.95657L0.534302 99.8771L62.1997 2.03209H85.4639L60.2695 44.1979L29.5892 94.6952H108.525ZM91.7625 2.03209V149.968H62.5045V2.03209H91.7625Z",
    fill: "url(#paint0_linear_1181_12553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.932 62.9947V88.599C223.932 99.7077 222.746 109.292 220.376 117.353C218.006 125.346 214.585 131.916 210.115 137.064C205.713 142.144 200.464 145.904 194.369 148.342C188.273 150.781 181.501 152 174.051 152C168.091 152 162.537 151.255 157.39 149.765C152.243 148.207 147.603 145.802 143.472 142.551C139.408 139.3 135.887 135.201 132.907 130.257C129.994 125.244 127.759 119.283 126.202 112.374C124.644 105.465 123.865 97.5402 123.865 88.599V62.9947C123.865 51.8859 125.05 42.369 127.421 34.4439C129.859 26.451 133.279 19.9144 137.681 14.8342C142.151 9.75401 147.434 6.02852 153.53 3.65776C159.625 1.21925 166.398 0 173.848 0C179.808 0 185.327 0.778966 190.407 2.3369C195.554 3.8271 200.193 6.164 204.325 9.3476C208.456 12.5312 211.978 16.6292 214.89 21.6417C217.802 26.5865 220.037 32.5134 221.595 39.4225C223.153 46.2638 223.932 54.1212 223.932 62.9947Z",
    fill: "url(#paint1_linear_1181_12553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.466 94.6952V117.658H240.897L239.475 99.8771L301.14 2.03209H324.405L299.21 44.1979L268.53 94.6952H347.466ZM330.703 2.03209V149.968H301.445V2.03209H330.703Z",
    fill: "url(#paint2_linear_1181_12553)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.265,
    cy: 54.6237,
    r: 8.21139,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.137,
    cy: 54.6237,
    r: 8.21139,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 99.7865C153.02 89.7112 162.476 82.3373 173.688 82.3373C184.899 82.3373 194.355 89.7112 197.295 99.7865",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_12553",
    x1: 0.534302,
    y1: 152,
    x2: 347.466,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#19C787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A71D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1181_12553",
    x1: 0.534302,
    y1: 152,
    x2: 347.466,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#19C787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A71D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1181_12553",
    x1: 0.534302,
    y1: 152,
    x2: 347.466,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#19C787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A71D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404Icon.19c142e7b220b511e623409e8bf98076.svg";
export { ForwardRef as ReactComponent };